// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IcHe","colBig":"styles_colBig__N3WUc","colSmall":"styles_colSmall__1tEPt"};